module.exports = __webpack_public_path__ + "img/image13.e17f414c.webp";